enum TaskDeliverablesTreeView {
    LIST = 'list',
    GRID = 'grid',
}

export default TaskDeliverablesTreeView;
